import { gql } from '@apollo/client';

// Activities list query
export const GET_ACTIVITIES_LIST_QUERY = gql`
  query GetActivitiesList($studySiteInvestigatorId: UUID!, $reconStatus: String, $limit: Int = 100, $offset: Int = 0) {
    activities(studySiteInvestigatorId: $studySiteInvestigatorId, reconStatus: $reconStatus, limit: $limit, offset: $offset) {
      edges {
        id
        activityName
        category
        paymentType
        visitName
        serviceDate
        patientNumber
        totalAmountMicros
        reconStatus
        createdAt
        invoiceId
        invoiceNumber
        invoiceDate
        paymentDate
      }
      totalCount
    }
  }
`;

// Activity detail query (for drawer view)
export const GET_ACTIVITY_DETAIL_QUERY = gql`
  query GetActivityDetail($activityId: UUID!, $studyId: UUID!) {
    activityDetail(activityId: $activityId, studyId: $studyId) {
      id
      studyId
      siteOrganizationId
      category
      paymentType
      activityName
      visitName
      serviceDate
      patientNumber
      patientStatus
      externalId
      sourceDocumentId
      createdAt
      createdByName
      lineItems {
        id
        lineNumber
        description
        billingCode
        amountMicros
        currencyCode
        reconStatus
        evidenceDocumentId
      }
      totalAmountMicros
      totalInvoicedMicros
      totalMatchedMicros
      overallReconStatus
      invoiceId
      invoiceNumber
      invoiceDate
      invoiceDocumentId
      paymentDate
    }
  }
`;

// Activity status history query (for Payment Proof on invoice detail)
export const GET_ACTIVITY_STATUS_HISTORY_QUERY = gql`
  query GetActivityStatusHistory($activityLineItemId: UUID!, $studyId: UUID!) {
    activityStatusHistory(activityLineItemId: $activityLineItemId, studyId: $studyId) {
      id
      activityLineItemId
      entityType
      entityId
      oldStatus
      newStatus
      reason
      changedBy
      createdAt
    }
  }
`;
